import { HomePageActionBase } from "./home-page-base-action";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { IHomePageAction } from "./i-home-page-action";
import { FormInstance } from "../../../models/site-content/form-instance.model";

export class CopyFormsAction extends HomePageActionBase implements IHomePageAction {
    public getTitle(): string {
        return "Copy Form(s)";
    }

    public permissionsRequiredToPerform(): string {
        return "CanCreateForm"
    }

    public requiresTree(): boolean {
        return true;
    }

    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        this.moveOrCopy = paramObj.moveOrCopy;
        let targetFolderId = paramObj.folderId;
        if (!this.moveOrCopy) {
            this.errorMessage = "Use the radio buttons above to select whether you want to Copy, Move or Create a Shortcut to the selected Form(s).";
            return;
        }

        if (this.move()) {
            this.message = "Moving selected Form(s)...";
            let formInstanceIds: number[] = this.formInstanceGridRows.map(x => { return x.Id });
            return this.folderService.moveFormInstances(formInstanceIds, targetFolderId).then(x => {
                return new HomePageActionDialogReturnObj();
            });
        } else if (this.copy() || this.createRef()) {
            this.message = `${this.copy() ? "Copying" : "Creating Shortcut(s) to"} selected Form(s)...`;
            let formInstances: FormInstance[] = this.formInstanceGridRows.map(x => {
                let fi = new FormInstance();
                fi.id = x.Id;
                fi.name = x.Name;
                return fi;
            });
            return this.folderService.copyFormInstances(targetFolderId, formInstances, this.createRef()).then(x => {
                return new HomePageActionDialogReturnObj();
            });
        }
    }
}
